import React, { useState } from "react";
import { useAppState } from "../RetailerFitGuide_StateContext.jsx";
import { getSolutionReferenceComponents } from "../Script/RetailerFitGuide_Utils.js";
import { getReferenceDisplayNameById } from "../Script/RetailerFitGuide_Utils.js";
export const RetailerFitGuide_SolutionItem = ({ solutionItem, hideImage }) => {
    const [expand, setExpand] = useState(false);

    const {
        setSelectedSolution,
        translations
    } = useAppState();

    const referenceData = getSolutionReferenceComponents(solutionItem);

    return <div className="retailerFitGuide_SolutionItem"><button onClick={() => setExpand(!expand)} className="solutionButton">
        {solutionItem.productImage?.ImageURL && <img src={solutionItem.productImage.ImageURL} alt={solutionItem.productImage.ImageAltText} />}
        <dl className="text-color--pitchBlack m-0 w-100 text-start">
            <dt className="heading5 text-color--gray80">{solutionItem.dataProductWebtitle1}</dt>
            <dd className="paragraph mb-0">{solutionItem.generationcalc === "Old" ? "(Old generation)" : solutionItem.dataProductColorSpecification}</dd>
        </dl>
        <i className={`le-icon-${expand ? "minus" : "plus"}`}></i>

    </button>
        {expand && <div className="referenceDataWrapper">
              {referenceData && referenceData.map((referenceDataItem, index) => {
                        if (referenceDataItem.Webtitle1)
                            return <dl key={index} className="referenceData">
                                <dt className="text-color--gray80 paragraph">{getReferenceDisplayNameById(referenceDataItem.ReferenceTypeId)}:</dt>
                                <dd className="d-flex justify-content-between heading5">
                                    <span>{referenceDataItem.Webtitle1}</span>
                                    <span className='retailerFitGuide_highlight'>{referenceDataItem.ProductId}</span>
                                </dd>
                            </dl>
                    })}
            <button onClick={() => setSelectedSolution(solutionItem)} className="btn thule-btn-default w-100">{translations.selectSystem}</button>
        </div>}
    </div>
}